import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CookieConsent from './components/CookieConsent.jsx';
import HomePage from './pages/HomePage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import PolicyPage from './pages/PolicyPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import JourneyPage from './pages/JourneyPage.jsx';

/**
 * The site opens on the homepage, where the customer picks home or business
 * before entering a journey.
 *
 * Journey routing stays intentionally open-ended: any single-segment path is
 * treated as a journey slug and validated by the API, so launching /ggbb4
 * needs a database row, not a route. The named pages below therefore have to
 * be declared before the catch-all, and the business homepage sits at
 * /for-business because `business` is already a live journey slug.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage brand="home" />} />
        <Route path="/for-business" element={<HomePage brand="business" />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PolicyPage policy="privacy" />} />
        <Route path="/cookies" element={<PolicyPage policy="cookies" />} />
        <Route path="/:slug" element={<JourneyPage />} />
        {/* Single-segment paths are journey slugs and 404 via the API; this
            catches everything deeper. */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}
